import { baseFaceToFace } from '../validations/face-to-face/v1';
const shape = baseFaceToFace.shape;
export const encounterFields = [
    { key: 'encounterDate', field: shape.encounterDate, formatDate: true },
    { key: 'encounterType', field: shape.encounterType },
];
export const certifyFields = [{ key: 'certifyDate', field: shape.certifyDate }];
export const medicalConditionsFields = [
    { key: 'medicalConditions', field: shape.medicalConditions },
];
export const homeboundReasonsFields = [
    { key: 'homeboundReasons', field: shape.homeboundReasons, variant: 'list' },
];
export const servicesFields = [
    { key: 'skilledNursingCare', field: shape.skilledNursingCare },
    { key: 'physicalTherapy', field: shape.physicalTherapy },
    { key: 'occupationalTherapy', field: shape.occupationalTherapy },
    { key: 'speechTherapy', field: shape.speechTherapy },
    { key: 'homeHealthAide', field: shape.homeHealthAide },
    { key: 'medicalSocialServices', field: shape.medicalSocialServices },
    { key: 'telehealthServices', field: shape.telehealthServices },
];
